import { ZGrid } from "@msidata/zeact";
import * as React from "react";
import styled from "styled-components";
import { getBooleanOption } from "../data/CompanyInfoContext";

const odata = {
      $select: [
         "EquipmentNumber",
         "Serial",
         "InventoryNumber",
         "Description",
         "Site/OwningCustomer/CustomerNumber",
         "Site/SiteNumber",
         "IsActive"
      ],
      $expand: ["Site/OwningCustomer", "Site"]
   };

export const EquipmentPage = (props: any) => {
   const hideInactiveEquipment = getBooleanOption("PortalHideInactiveEquipment", false);
   
   const EquipmentGrid = styled.div`
      margin-top: ${props.isWide ? `60px` : "55px"};
   `;

   return (
      <>
         <div>
            <EquipmentGrid id={"equipment-grid"}>
               <ZGrid
               endpoint={"Equipment/GetEquipment"}
               entity={"Equipment"}
               select={odata.$select}
               expand={odata.$expand}
               filter={
                 hideInactiveEquipment
                  ? {
                    logic: "and",
                    filters: [
                     {
                      field: "IsActive",
                      operator: "eq",
                      value: hideInactiveEquipment
                     }
                    ]
                   }
                  : undefined
               }
               style={{ width: "100%", height: 500 }}
               filterable={true}
               scrollable={"scrollable"}
               pageable={true}
               excelExport={true}
               columns={[
                 {
                  title: "EquipmentNumber",
                  field: "EquipmentNumber",
                  resizable: true
                 },
                 {
                  title: "InventoryNumber",
                  field: "InventoryNumber",
                  resizable: true
                 },
                 {
                  title: "SerialNumber",
                  field: "Serial",
                  resizable: true,
                  cell: (cellData: any) => {
                   if (cellData.dataItem.Serial) {
                     return (
                     <td className={cellData.className}>
                       {cellData.dataItem.Serial}
                     </td>
                     );
                   } else {
                     return <td className={cellData.className}>{"---"}</td>;
                   }
                  }
                 },
                 {
                  title: "Description",
                  field: "Description",
                  resizable: true,
                  cell: (cellData: any) => {
                   if (cellData.dataItem.Description) {
                     return (
                     <td className={cellData.className}>
                       {cellData.dataItem.Description}
                     </td>
                     );
                   } else {
                     return <td className={cellData.className}>{"---"}</td>;
                   }
                  }
                 },
                 {
                  title: "CustomerNumber",
                  field: "Site.OwningCustomer.CustomerNumber",
                  resizable: true
                 },
                 {
                  title: "SiteNumber",
                  field: "Site.SiteNumber",
                  resizable: true
                 },
                 ...(!hideInactiveEquipment
                  ? [
                   {
                     title: "IsActive",
                     field: "IsActive",
                     resizable: true,
                     filterable: false,
                     cell: (cellData: any) => {
                     return (
                       <td className={cellData.className}>
                        {cellData.dataItem.IsActive ? "true" : "---"}
                       </td>
                     );
                     }
                   }
                   ]
                  : [])
               ]}
               />
            </EquipmentGrid>
         </div>
      </>
   );
};

export default EquipmentPage;
